import { ProgramService, PropertyDiscoveryService } from "@adfenix/types";

export const DEDICATED_CUSTOMER = "boneo";
export const ADFENIX_TOKEN = "Adfenix_Token";
export const ADFENIX_GTM_ID = "GTM-T7X4K26";
export const COOKIE_CONSENT = "Cookie_Consent";
export const ALERT_MESSAGE_TIMESTAMP = "Alert_Message_Timestamp";
export const LOGIN_EMAIL_QUERY_STRING_PARAM = "email";
export const SUPPORTED_PROGRAM_SUBJECT_TYPES: ProgramService.SubjectType[] = [
  "Property",
  "Agent",
  "Office"
];

export const SUPPORTED_SUBJECT_ATTRIBUTE_TYPES: ProgramService.SubjectAttributeType[] =
  [
    "Hq",
    "Office",
    "Agent",
    "Property",
    "ProgramInstance",
    "Campaign",
    "Payment"
  ];

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const CUSTOM_ATTRIBUTE_TYPES: PropertyDiscoveryService.CustomAttributeTypes[] =
  ["Contains", "ContainsAny", "Regex", "RegexList"];
